const {
  REACT_APP_PROTECTED_GRAPHQL_ENDPOINT,
  REACT_APP_PUBLIC_API_KEY,
  REACT_APP_PUBLIC_GRAPHQL_ENDPOINT,
} = process.env;

const AppSync = {
  protectedGraphqlEndpoint: REACT_APP_PROTECTED_GRAPHQL_ENDPOINT,
  publicApiKey: REACT_APP_PUBLIC_API_KEY,
  publicGraphqlEndpoint: REACT_APP_PUBLIC_GRAPHQL_ENDPOINT,
};

export default AppSync;
